import { combineReducers } from "@reduxjs/toolkit";
import userReducer from "./user/userReducer";
import sectorReducer from "./sector/sectorReducer";
import clientReducer from "./client/clientReducer";
import agencyReducer from "./agency/agencyReducer";
import auditUploadReducer from "./audit/auditUploadReducer";
import auditPreviewReducer from "./audit/auditPreviewReducer";
import auditRawSheetsReducer from "./audit/auditRawSheetsReducer";
import clientSWOTReducer from "./client/clientSWOTReducer";
import clientClusterWiseReducer from "./client/clientClusterWiseReducer";
import auditUploadStatusReducer from "./audit/auditUploadStatusReducer";
import clientAddReducer from "./client/clientAddReducer";
import sectorWiseReducer from "./sector/sectorWiseReducer";
import sectorObservationReducer from "./sector/sectorObservationReducer";
import advisoryReducer from "./advisory/advisoryReducer";
import advisoryAddReducer from "./advisory/advisoryAddReducer";
import advisoryDelReducer from "./advisory/advisoryDelReducer";
import clientZScoreReducer from "./client/clientZScoreReducer";
import clientTrendReducer from "./client/clientTrendReducer";
import peerRequestReducer from "./user/peerRequestReducer";
import sectorPopularReducer from "./sector/sectorPopularReducer";
import sectorsReducer from "./sector/sectorsReducer";
import userProfileReducer from "./user/userProfileReducer";
import userDetailReducer from "./user/userDetailReducer";
import userExpertReducer from "./user/userExpertReducer";
import clientProductReducer from "./client/clientProductReducer";
import userUpdateReducer from "./user/userUpdateReducer";
import sectorSupplierReducer from "./sector/sectorSupplierReducer";
import chatbotReducer from "./user/chatBotReducer";
import earlyBirdOfferReducer from "./user/earlyBirdOfferReducer";
import pricingReducer from "./pricing/pricingReducer";
import orderReducer from "./order/orderReducer";
import locationSearchReducer from "./location/locationSearchReducer";
import locationDetailsReducer from "./location/locationDetailsReducer";
import sectorSummaryReducer from "./sector/sectorSummaryReducer";
import smechatbotReducer from "./sector/smeChatbotReducer";
import categorySizeReducer from "./sector/sectorCategoryReducer"
import expertDetailProfileReducer from "./user/userExpertDetailReducer";
import importDataReducer from "./sector/sectorImportDataReducer";
import exportDataReducer from "./sector/globalExportReducer";
import productReducer from "./sector/productReducer";
import userModuleReducer from "./user/userModuleReducer";
import sectorSmmReducer from "./sector/sectorSmmReducer";
import metricExpertReducer  from "./sector/metricExpertReducer";
import metricLevelInsightsReducer from "./sector/metricLevelInsightsReducer";
import expertImpactsReducer from "./sector/expertImpactsReducer";
import sessionReducer from "./user/sessionReducer";
import npsAdminReducer from "./user/npsAdminReducer"
export default combineReducers({
  userReducer,
  userProfileReducer,
  userDetailReducer,
  userUpdateReducer,
  userExpertReducer,
  earlyBirdOfferReducer,
  peerRequestReducer,
  sectorReducer,
  sectorsReducer,
  sectorWiseReducer,
  sectorObservationReducer,
  sectorPopularReducer,
  clientReducer,
  clientSWOTReducer,
  clientAddReducer,
  clientClusterWiseReducer,
  clientZScoreReducer,
  clientTrendReducer,
  clientProductReducer,
  userModuleReducer,
  agencyReducer,
  auditUploadReducer,
  auditPreviewReducer,
  auditRawSheetsReducer,
  auditUploadStatusReducer,
  advisoryReducer,
  advisoryAddReducer,
  advisoryDelReducer,
  sectorSupplierReducer,
  chatbotReducer,
  pricingReducer,
  orderReducer,
  locationSearchReducer,
  locationDetailsReducer,
  sectorSummaryReducer,
  smechatbotReducer,
  categorySizeReducer,
  expertDetailProfileReducer,
  importDataReducer,
  exportDataReducer,
  productReducer,
  sectorSmmReducer,
  metricExpertReducer,
  metricLevelInsightsReducer,
  expertImpactsReducer,
  sessionReducer,
  npsAdminReducer
});
